<template>
    <span>
        <v-row>
            <v-col>
              <router-link :to="'spklu'" class="text-decoration-none">
                <v-btn
                  class="ma-2 ml-0"
                  depressed
                  outlined
                  :color="colorInactive"
                >
                    <v-icon left :color="colorInactive">
                      $ic-house
                    </v-icon>
                    SPKLU
                </v-btn>
              </router-link>
              <router-link :to="'home-charging'" class="text-decoration-none">
                <v-btn
                  class="ma-2 ml-0"
                  depressed
                  outlined
                  :color="colorActive "
                >
                  <v-icon left :color="colorActive">
                    $ic-house
                  </v-icon>
                  Home Charging
                </v-btn>
              </router-link>
            </v-col>
            <v-spacer></v-spacer>
            <v-col class="text-right">
              <v-btn
                class="ma-2"
                depressed
                outlined
                :color="colorActive"
                @click="openDialog()"
              >
                <v-icon left :color="colorActive">
                  $ic-filter
                </v-icon>
                Filter
              </v-btn>
            </v-col>
          </v-row>
          <span>
            <v-row>
              <v-col v-for="(data, i) in summaryCardsHomeCharging" :key="i">
                <v-card flat outlined>
                  <v-card-text>
                    <p>
                      <span class="summary-title">{{ data.title }}</span>
                      <span v-if="data.id === 'transaksi' || data.id === 'pengguna'" class="summary-value">{{ formatCurrency(data.value).split(',')[0] }}</span>
                      <span v-else class="summary-value">{{ formatCurrency(data.value) }}</span>
                    </p>
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>
            <!-- chart 1 -->
            <v-row>
              <v-col cols="6">
                <v-card flat outlined>
                  <v-card-title class="pb-0">
                    <p>
                      <span style="font-weight: 600; font-size: 18px;">Home Charging Terintegrasi 2022</span>
                      <span style="font-color:#9A9A9A;font-size:14px;">Data Keseluruhan</span>
                    </p>
                  </v-card-title>
                  <v-card-text>
                    <span v-if="(this.input.periode === undefined && !isLoading) || (this.input.periode && this.input.periode.id === 'daily' && !isLoading)">
                      <LineChartGenerator
                        :chart-options="chartOptionsLine"
                        :chart-data="chartLineDataKwh"
                      />
                    </span>
                    <span v-else-if="!isLoading">
                      <Bar
                        :chart-options="chartOptionsBar"
                        :chart-data="chartBarDataKwh"
                      />
                    </span>
                  </v-card-text>
                </v-card>
              </v-col>
              <v-col cols="6">
                <v-card flat outlined>
                  <v-card-title class="pb-0">
                    <p>
                      <span style="font-weight: 600; font-size: 18px;">Energi Pemakaian Home Charging (kWh) 2022</span>
                      <span style="font-color:#9A9A9A;font-size:14px;">Data Keseluruhan</span>
                    </p>
                  </v-card-title>
                  <v-card-text>
                    <span v-if="(this.input.periode === undefined && !isLoading) || (this.input.periode && this.input.periode.id === 'daily' && !isLoading)">
                      <LineChartGenerator
                        :chart-options="chartOptionsLine"
                        :chart-data="chartLineDataKwh"
                      />
                    </span>
                    <span v-else-if="!isLoading">
                      <Bar
                        :chart-options="chartOptionsBar"
                        :chart-data="chartBarDataKwh"
                      />
                    </span>
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>
            <!-- chart 2 -->
            <v-row>
              <v-col cols="6">
                <v-card flat outlined>
                  <v-card-title class="pb-0">
                    <p>
                      <span style="font-weight: 600; font-size: 18px;">Energi Pemakaian Diskon Home Charging (kWh) 2022</span>
                      <span style="font-color:#9A9A9A;font-size:14px;">Data Keseluruhan</span>
                    </p>
                  </v-card-title>
                  <v-card-text>
                    <span v-if="(this.input.periode === undefined && !isLoading) || (this.input.periode && this.input.periode.id === 'daily' && !isLoading)">
                      <LineChartGenerator
                        :chart-options="chartOptionsLine"
                        :chart-data="chartLineDataKwh"
                      />
                    </span>
                    <span v-else-if="!isLoading">
                      <Bar
                        :chart-options="chartOptionsBar"
                        :chart-data="chartBarDataKwh"
                      />
                    </span>
                  </v-card-text>
                </v-card>
              </v-col>
              <v-col cols="6">
                <v-card flat outlined>
                  <v-card-title class="pb-0">
                    <p>
                      <span style="font-weight: 600; font-size: 18px;">Home Charging Terintegrasi (UID/UIW) 2022</span>
                      <span style="font-color:#9A9A9A;font-size:14px;">Data Keseluruhan</span>
                    </p>
                  </v-card-title>
                  <v-card-text>
                    <span v-if="(this.input.periode === undefined && !isLoading) || (this.input.periode && this.input.periode.id === 'daily' && !isLoading)">
                      <LineChartGenerator
                        :chart-options="chartOptionsLine"
                        :chart-data="chartLineDataKwh"
                      />
                    </span>
                    <span v-else-if="!isLoading">
                      <Bar
                        :chart-options="chartOptionsBar"
                        :chart-data="chartBarDataKwh"
                      />
                    </span>
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>
          </span>
          <!-- filter data -->
          <v-dialog
      v-model="dialog"
      persistent
      max-width="600px"
    >
      <v-card>
        <v-card-title>
          <v-row>
            <v-col>
              <span>Filter Data</span>
            </v-col>
            <v-col class="text-right">
              <v-btn
                icon
                x-small
                @click="closeDialog()"
              >
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-col>
          </v-row>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col class="pb-5 pt-1">
                <div class="label mb-2" :style="'color:' + colorActive">Periode</div>
                <v-menu
                  ref="menuDateRange"
                  v-model="menuDateRange"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      :value="formattedDateRange"
                      readonly
                      clearable
                      @click:clear="changeDateRangeType()"
                      v-bind="attrs"
                      v-on="on"
                      dense
                      solo
                      flat
                      outlined
                      hide-details
                      append-icon="mdi-calendar"
                      placeholder="Semua Periode"
                      :color="colorActive"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="dateRange"
                    :active-picker.sync="activePicker"
                    :max="(new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10)"
                    range
                    locale="id-ID"
                    :color="colorActive"
                    :type="dpTypeChooser()"
                    @click:year="(input.periode && input.periode.id === 'monthly') ? setDateRange(dateRange) : ''"
                  >
                    <v-spacer></v-spacer>
                    <v-btn
                      text
                      :color="colorActive"
                      @click="setDateRange"
                    >
                      OK
                    </v-btn>
                  </v-date-picker>
                </v-menu>
              </v-col>
            </v-row>
            <v-row v-if="isShowOptionHomeCharging">
              <v-col class="pb-0 pt-1">
                <div class="label-custom mb-2" :style="'color:' + colorActive">Unit Wilayah</div>
                <v-autocomplete
                  v-model="input.homecharging"
                  :items="optionsHomeCharging"
                  label="Semua Unit Wilayah"
                  dense
                  solo
                  flat
                  outlined
                  item-text="name"
                  item-value="id"
                  return-object
                  cache-items
                  :color="colorActive"
                  :search-input.sync="searchHomeChargingKeyword"
                  :loading="awaitingSearch"
                  clearable
                >
                </v-autocomplete>
              </v-col>
            </v-row>
            <v-row v-if="isShowOptionBranch">
              <v-col class="pb-0 pt-1">
                <div class="label mb-2" :style="'color:' + colorActive">Lokasi</div>
                <v-text-field
                  v-model="input.searchBranch"
                  label="Cari Lokasi"
                  dense
                  solo
                  flat
                  outlined
                  clearable
                >
                </v-text-field>
                <span>Selected: {{ input.branch.name ? input.branch.name : 'belum dipilih' }}
                  <v-icon v-show="input.branch.id" @click="input.branch = {}; active = []">mdi-close</v-icon>
                </span>
                <div style="overflow-y: scroll; height:300px;">
                  <v-treeview
                    activatable
                    :active="active"
                    :items="tempOptionsBranch"
                    @update:active="treeClick"
                  ></v-treeview>
                </div>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            small
            depressed
            color="#999999"
            text
            @click="closeDialog()"
          >
            Kembali
          </v-btn>
          <v-btn
            small
            depressed
            :color="colorActive"
            @click="dialog = false; reGetChart();"
            dark
          >
            Cari
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
        </span>
      </template>
<script>
import { Bar, Line as LineChartGenerator } from 'vue-chartjs'
import DashboardService from '@/services/default/DashboardService'
import RefService from '@/services/default/RefService'
import {
  Chart as ChartJS,
  Title,
  Tooltip,
  Legend,
  BarElement,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Filler
} from 'chart.js'

const dashboardService = DashboardService.build()
const refService = RefService.build()

ChartJS.register(Title, Tooltip, Legend, BarElement, CategoryScale, LinearScale, PointElement, LineElement, Filler)
export default {
  name: 'Dashboard-Home-Charging',
  components: {
    Bar,
    LineChartGenerator
  },
  data: () => ({
    colorActive: '#2671D9',
    colorInactive: '#9A9A9A',
    dialog: false,
    searchHomeChargingKeyword: '',
    awaitingSearch: false,
    optionsHomeCharging: [],
    optionsBranch: [],
    isShowOptionHomeCharging: true,
    isShowOptionBranch: true,
    tempOptionsBranch: [],
    optionsTipePeriode: [
      { id: 'hourly', name: 'Hourly' },
      { id: 'daily', name: 'Daily' },
      // { id: 'weekly', name: 'Weekly' },
      { id: 'monthly', name: 'Monthly' },
      { id: 'yearly', name: 'Yearly' }
    ],
    input: {
      cakupan: {},
      periode: { id: 'hourly', name: 'Hourly' },
      branch: { id: '', name: '' },
      searchBranch: '',
      spklu: { id: '', name: '' }
    },
    active: [],
    menuDateRange: false,
    dateRange: null,
    activePicker: null,
    // dashboard variable
    dash_active: '',
    // chart properties dashboard homecharging
    isLoading: false,
    chartLineDataTransaksi: {
      // put chart label here (y axis)
      labels: [],
      datasets: [
        {
          label: 'Jumlah Transaksi',
          backgroundColor: '#d4e3f7',
          borderColor: '#2671D9',
          // put chart data here
          data: [],
          fill: 'start',
          tension: 0.4
        }
      ]
    },
    chartBarDataTransaksi: {
      // put chart label here (y axis)
      labels: [],
      datasets: [
        {
          label: 'Jumlah Transaksi',
          backgroundColor: '#2671D9',
          // put chart data here
          data: [],
          barThickness: 15
        }
      ]
    },
    chartOptionsLine: {
      responsive: true,
      maintainAspectRatio: true,
      plugins: {
        legend: {
          display: false
        },
        tooltip: {
          callbacks: {
            label: function (context) {
              let label = context.dataset.label || ''

              if (label) {
                label += ': '
              }
              if (context.parsed.y !== null) {
                const isHasDecimal = context.parsed.y - Math.floor(context.parsed.y) !== 0
                // Indonesian's number format
                if (isHasDecimal) {
                  const value = (context.parsed.y / 1).toFixed(2).replace('.', ',')
                  label += value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')
                } else {
                  label += context.parsed.y.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')
                }
              }
              return label
            }
          }
        }
      },
      scales: {
        y: {
          ticks: {
            // Indonesian's number format
            callback: (label) => `${label.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')}`
          }
        }
      }
    },
    chartLineDataKwh: {
      // put chart label here (y axis)
      labels: [],
      datasets: [
        {
          label: 'kWh Terjual',
          backgroundColor: '#d4e3f7',
          borderColor: '#2671D9',
          // put chart data here
          data: [],
          fill: 'start',
          tension: 0.4
        }
      ]
    },
    chartBarDataKwh: {
      // put chart label here (y axis)
      labels: [],
      datasets: [
        {
          label: 'kWh Terjual',
          backgroundColor: '#2671D9',
          // put chart data here
          data: [],
          barThickness: 15
        }
      ]
    },
    chartOptionsBar: {
      responsive: true,
      maintainAspectRatio: true,
      plugins: {
        legend: {
          display: false
        },
        tooltip: {
          callbacks: {
            label: function (context) {
              let label = context.dataset.label || ''

              if (label) {
                label += ': '
              }
              if (context.parsed.y !== null) {
                const isHasDecimal = context.parsed.y - Math.floor(context.parsed.y) !== 0
                // Indonesian's number format
                if (isHasDecimal) {
                  const value = (context.parsed.y / 1).toFixed(2).replace('.', ',')
                  label += value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')
                } else {
                  label += context.parsed.y.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')
                }
              }
              return label
            }
          }
        }
      },
      scales: {
        y: {
          ticks: {
            // Indonesian's number format
            callback: (label) => `${label.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')}`
          }
        }
      }
    },
    summaryCardsHomeCharging: [
      { id: 'transaksi', title: 'Home Charging Terintegrasi 2022 (Unit)', value: 0 },
      { id: 'kwh', title: 'Energi Pemakaian Home Charging (kWh) 2022', value: 0 },
      { id: 'rupiah', title: 'Energi Pemakaian Diskon Home Charging (kWh) 2022', value: 0 }
    ]
  }),
  async created () {
    this.getCardData()
    this.getChartData()
  },
  computed: {
    formattedDateRange () {
      if (this.dateRange) {
        if (this.input.periode.id === 'monthly') {
          return this.dateRange.split('-')[0]
        } else if (this.input.periode.id === 'hourly' || this.input.periode.id === 'daily') {
          return this.dateRange
        } else if (this.input.periode.id === 'weekly') {
          return this.dateRange.join(' ~ ')
        }
      }
      return ''
    }
  },
  mounted: function () {},
  watch: {
    menuDateRange (val) {
      if (this.input.periode.id === 'monthly') {
        val && this.$nextTick(() => (this.activePicker = 'YEAR'))
      } else if (this.input.periode.id === 'daily') {
        val && this.$nextTick(() => (this.activePicker = 'MONTH'))
      } else if (this.input.periode.id === 'hourly') {
        val && this.$nextTick(() => (this.activePicker = 'DATE'))
      } else {
        val && this.$nextTick(() => (this.activePicker = null))
      }
    },
    searchHomeChargingKeyword (val) {
      const self = this
      if (!this.awaitingSearch) {
        setTimeout(() => {
          if (val !== '' && val !== null) {
            self.getOptionsHomeCharging()
          }
          self.awaitingSearch = false
        }, 1000)
      }
      this.awaitingSearch = true
    },
    'input.searchBranch': function (val) {
      if (!val) {
        this.tempOptionsBranch = this.optionsBranch
      } else {
        this.tempOptionsBranch = this.containComplex(this.optionsBranch, val)
      }
    },
    'input.branch': function (val) {
      if (val.id) {
        this.getOptionsHomeCharging(val.id)
      }
    }
  },
  methods: {
    closeDialog () {
      this.dialog = false
      this.isLoading = false
    },
    openDialog () {
      this.getOptionsBranch()
      this.dialog = true
      this.isLoading = true
    },
    setDateRange (date) {
      this.$refs.menuDateRange.save(date)
    },
    async getCardData (param) {
      const response = await dashboardService.getCardDashboardHomeCharging(param)
      const { data } = response
      if (data.success !== true) return

      for (let i = 0; i < this.summaryCardsHomeCharging.length; i++) {
        this.summaryCardsHomeCharging[i].value = data.data[this.summaryCardsHomeCharging[i].id]
      }
    },
    async getChartData (param) {
      const response = await dashboardService.getChartDashboardHomeCharging(param)
      const { data } = response
      if (data.success !== true) return

      if (this.input.periode === undefined || this.input.periode.id === 'daily') {
        this.chartLineDataTransaksi.labels = []
        this.chartLineDataTransaksi.datasets[0].data = []
        this.chartLineDataKwh.labels = []
        this.chartLineDataKwh.datasets[0].data = []

        // set data and y axis label for chart line
        for (let i = 0; i < data.data.length; i++) {
          // hours label format
          const label = data.data[i].periode.toString() + '.00'

          this.chartLineDataTransaksi.labels.push(label)
          this.chartLineDataTransaksi.datasets[0].data.push(data.data[i].transaksi)

          this.chartLineDataKwh.labels.push(label)
          this.chartLineDataKwh.datasets[0].data.push(data.data[i].kwh)
        }
      } else {
        this.chartBarDataTransaksi.labels = []
        this.chartBarDataTransaksi.datasets[0].data = []
        this.chartBarDataKwh.labels = []
        this.chartBarDataKwh.datasets[0].data = []

        // set data and y axis label for chart bar
        for (let i = 0; i < data.data.length; i++) {
          const label = data.data[i].periode

          this.chartBarDataTransaksi.labels.push(label)
          this.chartBarDataTransaksi.datasets[0].data.push(data.data[i].transaksi)

          this.chartBarDataKwh.labels.push(label)
          this.chartBarDataKwh.datasets[0].data.push(data.data[i].kwh)
        }
      }
    },
    async reGetChart () {
      let q = ''
      if (this.input.homecharging) {
        q = this.input.homecharging.id
      } else if (this.input.branch) {
        q = this.input.branch.id
      }

      const param = {
        periodeType: this.input.periode.id,
        periode: this.formattedDateRange,
        q: q
      }
      this.getCardData(param)
      this.getChartData(param)
      this.isLoading = false
    },
    colorPicker (status) {
      if (status === 'Aktif') return '#397E5D'
      else if (status === 'Non Aktif') return '#DD6068'
      else return '#2671D9'
    },
    async getOptionsHomeCharging (id) {
      this.paging.page = 0
      this.paging.size = 20

      // const param = Object.assign({ q: this.searchSpkluKeyword }, this.paging)
      const param = Object.assign({ q: id }, this.paging)
      const response = await refService.getSpkluList(param)
      const { data } = response
      if (data.success !== true) return

      this.optionsHomeCharging = data.data.content.map((data) => {
        return {
          id: data.idSpklu,
          name: data.spkluName
        }
      })
    },
    async getOptionsBranch () {
      const branch = JSON.parse(localStorage.getItem('branch_list'))?.data
      if (branch) {
        this.optionsBranch = branch
        this.tempOptionsBranch = branch
      } else {
        const param = {
          companyId: 1,
          branchId: ''
        }
        const response = await refService.getBranchList(param)
        const { data: { data } } = response

        const temp = data.map(item => {
          // remap level 1
          item.child = item.child.map(item2 => {
            // remap level 2
            item2.child = item2.child.map(item3 => {
              // remap level 3
              item3.child = item3.child.map(item4 => {
                // remap level 4
                return {
                  id: item4.id,
                  name: item4.id.split('').join('.') + ' - ' + item4.name,
                  children: item4.child
                }
              })
              return {
                id: item3.id,
                name: item3.id.split('').join('.') + ' - ' + item3.name,
                children: item3.child
              }
            })
            return {
              id: item2.id,
              name: item2.id.split('').join('.') + ' - ' + item2.name,
              children: item2.child
            }
          })
          return {
            id: item.id,
            name: item.id.split('').join('.') + ' - ' + item.name,
            children: item.child
          }
        })

        this.optionsBranch = temp
        this.tempOptionsBranch = temp

        localStorage.setItem('branch_list', JSON.stringify({
          data: temp
        }))
      }
    },
    treeClick (value) {
      if (value.length > 0) {
        const branch = JSON.parse(localStorage.getItem('branch_list'))?.data
        this.input.branch = this.findComplex(branch, value[0])
        this.input.homecharging = {}
      }
    },
    changeDateRangeType () {
      // this.dateRange = null
      // if (this.input.periode.id === 'hourly' || this.input.periode.id === 'daily' || this.input.periode.id === 'monthly' || this.input.periode.id === 'yearly') {
      //   this.dateRange = null
      // } else {
      //   // for weekly
      //   this.dateRange = []
      // }
    },
    dpTypeChooser () {
      if ((this.input.periode && this.input.periode.id === 'monthly') || (this.input.periode && this.input.periode.id === 'hourly')) return undefined
      else if (this.input.periode && this.input.periode.id === 'daily') return 'month'
      else return 'date'
    }
  }
}
</script>
      <style scoped>
        .summary-title {
          font-weight: 400;
          font-size: 16px;
          color: #333333;
          padding: 5% 5% 0% 5%;
        }

        .summary-value {
          font-weight: 600;
          font-size: 24px;
          color: #333333;
          padding: 10% 5% 0% 5%;
        }

        p span {
          display: block;
        }

        .percentage-value {
          font-weight: 700;
          font-size: 14px;
          color: #333333;
        }

        .percentage-up {
          font-weight: 600;
          font-size: 14px;
          align-items: center;
          color: #56A452;
        }

        .percentage-down {
          font-weight: 600;
          font-size: 14px;
          align-items: center;
          color: #DD6068;;
        }

        .summary-alert-title {
          font-weight: 400;
          font-size: 14px;
          color: #9A9A9A;
        }

        .summary-alert-value {
          font-weight: 600;
          font-size: 18px;
          color: #000000;
        }
      </style>
